/**
 * F61 (A7) — the F04 geo lookups (`/geo/governorates`, `/geo/cazas`,
 * `/geo/cities`) are static reference data, but each admin page re-fetched
 * them on every mount. One request per path for the whole session; a failed
 * request is not cached, so the next mount retries.
 */
import { createCachedLoader } from '@bravemove/utils/cache';
import { adminFetch } from '../auth/apiClient';

const loader = createCachedLoader<string, unknown>((path) => adminFetch<unknown>(path), {
  ttlMs: Infinity,
});

/** GET a `/geo/...` path through the session cache (the body is shared — read-only). */
export function getGeo<T>(path: string): Promise<T> {
  return loader.get(path) as Promise<T>;
}

/** Test-only: forget the session geo cache. */
export function __resetGeoCache(): void {
  loader.invalidate();
}
